import { render, staticRenderFns } from "./CaseInformationPanel.vue?vue&type=template&id=c48ef8c4&scoped=true"
import script from "./CaseInformationPanel.vue?vue&type=script&lang=js"
export * from "./CaseInformationPanel.vue?vue&type=script&lang=js"
import style0 from "./CaseInformationPanel.vue?vue&type=style&index=0&id=c48ef8c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48ef8c4",
  null
  
)

export default component.exports